import * as constants from './constants';
import { authSlice } from './slice';

export default { constants, authSlice };
